import React from 'react'
import { SanityTwoColumnText } from '../../types/generated/graphql-types'
import { TwoColumnTextProps } from '../components/blocks/TwoColumnText'
import { RichTextArea } from '../components/PortableText/RichTextArea'
import { TwoColumnTextBlockSerializer } from '../components/PortableText/serializers/blocks/TwoColumnTextBlockSerializer'
import { TwoColumnTextListSerializer } from '../components/PortableText/serializers/lists/TwoColumnTextListSerializer'
import { IS_EQT_FUNDS } from '../utilities/site'

export const mapSanityTwoColumnTextToTwoColumnTextProps = ({
  _rawBody,
  _rawPreambleFormatted,
  preamble,
  preambleAsBody,
  title,
}: SanityTwoColumnText): TwoColumnTextProps => ({
  blockContent: !IS_EQT_FUNDS ? (
    <RichTextArea value={_rawBody ?? []} />
  ) : (
    <div className="font-body text-body text-secondary-darkest">
      <RichTextArea
        components={{
          block: TwoColumnTextBlockSerializer,
          list: TwoColumnTextListSerializer,
        }}
        value={_rawBody ?? []}
      />
    </div>
  ),
  preamble: preamble ?? '',
  preambleFormatted: _rawPreambleFormatted ?? undefined,
  preambleAsBody: preambleAsBody ?? undefined,
  title: title ?? '',
})
